module.exports = __webpack_public_path__ + "img/ipad-en-9.eb694e8.jpg";